export default "__VITE_ASSET__408fb4d0__"